<template>
  <!-- Diálogo de ayuda REUTILIZABLE (se carga dentro de EpcModalWrapper). Muestra,
       si se le pasan, una sección de herramientas/menús (icono + descripción) y
       otra de atajos de teclado (descripción + teclas). Es presentacional: el host
       le pasa los textos ya traducidos (intro, títulos, label/desc), así este
       componente no conoce claves i18n. Generalizado del ViewerHelpDialog. -->
  <div class="epc-help-dialog">
    <p v-if="intro" class="epc-help-intro">{{ intro }}</p>

    <div class="epc-help-grid">
      <section v-if="tools && tools.length" class="epc-help-island">
        <h4 class="epc-help-island-title">{{ toolsTitle }}</h4>
        <div class="epc-help-rows">
          <div class="epc-help-row epc-help-row--tool" v-for="(t, i) in tools" :key="'tl_' + i">
            <span class="epc-help-tool-icon">
              <b-icon :icon="t.icon" :pack="t.pack || 'fas'" size="is-small"></b-icon>
            </span>
            <span class="epc-help-desc">{{ t.label }}</span>
          </div>
        </div>
      </section>

      <section v-if="shortcuts && shortcuts.length" class="epc-help-island">
        <h4 class="epc-help-island-title">{{ shortcutsTitle }}</h4>
        <div class="epc-help-rows">
          <div class="epc-help-row" v-for="(s, i) in shortcuts" :key="'sc_' + i">
            <span class="epc-help-desc">{{ s.desc }}</span>
            <span class="epc-help-keys">
              <kbd class="epc-help-kbd" v-for="(k, j) in s.keys" :key="'k_' + i + '_' + j">{{ k }}</kbd>
            </span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpDialog",

  props: {
    // Línea introductoria (texto ya traducido). Opcional.
    intro: { type: String, default: null },
    // [{ icon, pack?, label }] — herramientas/menús (label ya traducido).
    tools: { type: Array, default: () => [] },
    // Título de la sección de herramientas (ya traducido).
    toolsTitle: { type: String, default: '' },
    // [{ desc, keys: [] }] — atajos de teclado (desc ya traducido). Opcional.
    shortcuts: { type: Array, default: () => [] },
    // Título de la sección de atajos (ya traducido).
    shortcutsTitle: { type: String, default: '' },
  },
}
</script>

<style scoped>
.epc-help-dialog {
  color: #343a40;
}

.epc-help-intro {
  font-size: 13px;
  color: #868e96;
  margin-bottom: 16px;
}

.epc-help-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.epc-help-island {
  background-color: #f7f7fb;
  border: 1px solid #ececf1;
  border-radius: 10px;
  padding: 12px 14px;
}

.epc-help-island-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6965db;
  margin-bottom: 10px;
}

.epc-help-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.epc-help-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}

.epc-help-row--tool {
  justify-content: flex-start;
  gap: 10px;
}

.epc-help-desc {
  color: #343a40;
}

.epc-help-keys {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
}

.epc-help-kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  background-color: #ffffff;
  border: 1px solid #dcdce4;
  border-bottom-width: 2px;
  border-radius: 5px;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  color: #495057;
}

.epc-help-tool-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid #e3e3e8;
  color: #495057;
  flex-shrink: 0;
}
</style>
